import classNames from 'classnames';

import ArrowRightIcon from '@svg/arrows-right.svg';
import { Button } from '@ui/Button';

import s from './FeedFilterTitle.sss';

interface Props {
  title: React.ReactNode,
  hide: boolean,
  onClick: () => void,
}

export const FeedFilterTitle: React.FC<Props> = ({
  title,
  hide,
  onClick,
}) => (
  <div className={s.root}>
    <p className={s.title}>
      {title}
    </p>

    <Button
      className={s.arrowButton}
      theme="text"
      onClick={onClick}
    >
      <ArrowRightIcon
        className={classNames(s.arrowIcon, {
          [s.arrowIconStateClose]: hide,
        })}
        width="24"
        height="24"
      />
    </Button>
  </div>
);

export default FeedFilterTitle;
